// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__RzJCR","show":"show__FUPPm"};